<template>
  <VFacebookLogin app-id="appId" @sdk-init="onSdkInit" @login="onAuthSuccess" />
</template>

<script>
  import VFacebookLogin from "vue-facebook-login-component";

  export default {
    name: "FacebookAuthBtn",
    components: { VFacebookLogin },
    data() {
      return {
        appId: process.env.FB_OAUTH_APP_ID,
        FB: {},
        scope: {},
        recaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY,
      };
    },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
    methods: {
      redirectToDashboard(role) {
        if (role) {
          if (role.indexOf("parent") > -1) {
            this.$router.replace("/parentdashboard");
          }

          if (role.indexOf("child") > -1) {
            this.$router.replace("/childdashboard");
          }
        } else {
          this.$router.replace("/oops");
        }
      },
      onSdkInit({ FB, scope }) {
        this.FB = FB;
        this.scope = scope;
        this.$sdkInstances.setFbSDKInstance(FB);
      },

      authFail(error) {
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });
        delete localStorage.token;
        delete localStorage.role;
      },

      onAuthSuccess() {
        const authResponse = this.FB.getAuthResponse();
        const fbUserInfoUrl = "/me?fields=name,email,picture";
        const user = {};

        if (!authResponse.accessToken) {
          this.authFail();
          return;
        }

        //Fetch user info from FB
        FB.api(fbUserInfoUrl, (response) => {
          if (response.error) {
            this.$store.commit("setError", {
              message: "Could not authenticate with Facebook, Please try again",
              type: "error",
            });
            console.error(response.error.message);
          } else {
            user.name = response.name;
            user.email = response.email;
            user.avatar = response.picture.data.url;

            // Do google recaptcha check
            grecaptcha.ready(() => {
              grecaptcha
                .execute(this.recaptchaSiteKey, { action: "submit" })
                .then(
                  (token) => {
                    this.$http
                      .post("/recaptcha/verify", { token: token })
                      .then((response) => {
                        //Send info to backend and store response
                        this.$http
                          .post("/oauth/fb", {
                            email: user.email,
                            access_token: authResponse.accessToken,
                          })
                          .then((response) => {
                            user.token = response.data.token;
                            user.role = response.data.role;
                            user.lastLogin = this.$datetime.getCurrentTimeInMillisec();
                            this.$store.commit("setUserInfo", user);
                            this.$store.commit("dismissError");
                            localStorage.token = response.data.token;
                            localStorage.role = response.data.role;
                            this.$sessionUser._updateUserInfo(user);
                            this.redirectToDashboard(user.role);
                          })
                          .catch(() => {
                            this.$store.commit("setError", {
                              message: "Could not authenticate with Facebook, Please try again",
                              type: "error",
                            });
                          });
                      })
                      .catch(() => {
                        this.$store.commit("setError", {
                          message: "Could not authenticate with Facebook, Please try again",
                          type: "error",
                        });
                      });
                  },
                  (error) => {
                    console.error(error);
                    this.$store.commit("setError", {
                      message: "Could not authenticate with Facebook, Please try again",
                      type: "error",
                    });
                  }
                )
                .catch((error) => {
                  console.error(error);
                  this.$store.commit("setError", {
                    message: "Could not authenticate with Facebook, Please try again",
                    type: "error",
                  });
                });
            });
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/FacebookAuthBtn.vue